import MarkdownIt from "markdown-it";

const md: MarkdownIt = new MarkdownIt("zero")
  .enable(["linkify", "link", "emphasis", "heading"])
  .set({ linkify: true });

md.linkify.add("@", {
  validate: function (text, pos, self) {
    var tail = text.slice(pos);

    if (!self.re.mention) {
      self.re.mention = new RegExp(
        "^([a-zA-Z0-9_]){1,15}(?!_)(?=$|" + self.re.src_ZPCc + ")"
      );
    }
    if (self.re.mention.test(tail)) {
      if (pos >= 2 && tail[pos - 2] === "@") {
        return false;
      }
      return (tail.match(self.re.mention) || [])[0].length;
    }
    return 0;
  },
  normalize: function (match) {
    match.url = "/p/" + match.url.replace(/^@/, "");
  },
});

export default md;
